import { useTranslation } from 'react-i18next';
import { ShareDeviceDialogBase } from './ShareDeviceDialogBase';
import { MESSAGE_KEY, type MessageKey } from '@/constants/dialog';

interface ShareDeviceDialogContentNoAvailableSlotsProps {
  onConfirm: () => void;
  messageKey?: MessageKey;
}

export const ShareDeviceDialogContentNoAvailableSlots = ({
  onConfirm,
  messageKey = MESSAGE_KEY.FULLY_BOOKED,
}: ShareDeviceDialogContentNoAvailableSlotsProps) => {
  const { t } = useTranslation();

  const message =
    messageKey === MESSAGE_KEY.OUTSIDE_BUSINESS_HOURS
      ? t('shareDevice.timeSelection.outsideBusinessHoursMessage')
      : t('shareDevice.timeSelection.fullyBookedMessage');

  return (
    <ShareDeviceDialogBase>
      <div className="dialog__text">
        <p className="dialog__text-line dialog__text-line-left">{message}</p>
      </div>
      <div className="f4__actions">
        <button
          className="dialog__btn dialog__btn--ok js-bt-dialog"
          type="button"
          onClick={onConfirm}
        >
          OK
        </button>
      </div>
    </ShareDeviceDialogBase>
  );
};
